import React, { memo } from 'react';
import { TimeSignalAttribute } from 'graphql/types';
import { FormTimesheetLabel } from 'modules/timesheet-labels/labelSchema';
import { TimesheetLabels } from 'modules/timesheet-labels';
import { useFetchSuggestions } from './hooks';

type TimesheetLabelsContentProps = {
  loading: boolean;
  fields: FormTimesheetLabel[];
  attributes?: TimeSignalAttribute[] | undefined;
};

const TimesheetLabelsContent: React.FC<TimesheetLabelsContentProps> = ({
  loading,
  fields,
  attributes
}: TimesheetLabelsContentProps) => {
  const fetchSuggestions = useFetchSuggestions();

  return (
    <TimesheetLabels
      loading={loading}
      fields={fields}
      attributes={attributes}
      onLabelChange={fetchSuggestions}
    />
  );
};

export default memo(TimesheetLabelsContent);
